<script setup lang="ts">
const { styles } = useVariants('themeLogo')
</script>

<template>
  <div :class="styles.wrapper()">
    <div :class="styles.image()" />
  </div>
</template>
